import { render, staticRenderFns } from "./PackageServicePaymentDetail.vue?vue&type=template&id=0345a336&scoped=true&"
import script from "./PackageServicePaymentDetail.vue?vue&type=script&lang=js&"
export * from "./PackageServicePaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./PackageServicePaymentDetail.vue?vue&type=style&index=0&id=0345a336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0345a336",
  null
  
)

export default component.exports